import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { KEY_FEATURES, TOOLS } from '../data/content';
import { Radio, Users, Briefcase, BrainCog, Compass, Infinity as InfinityIcon } from 'lucide-react';

const ICONS = { Radio, Users, Briefcase, BrainCog, Compass, Infinity: InfinityIcon };

export default function KeyFeatures() {
  return (
    <>
      <section id="why" className="py-24 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><SectionLabel>Why ExcellenC</SectionLabel></Reveal>
          <Reveal delay={0.1}>
            <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-4xl">
              An experience engineered around <span className="text-[#293891]">your outcome.</span>
            </h2>
          </Reveal>

          <div className="mt-14 border border-[#293891]/10 rounded-3xl overflow-hidden bg-[#F9FAFF]">
            <div className="grid sm:grid-cols-2 lg:grid-cols-3">
              {KEY_FEATURES.map((f,i) => {
                const Icon = ICONS[f.icon] || Users;
                return (
                  <Reveal key={f.title} delay={i*0.06}>
                    <div className="p-8 border-b lg:border-b border-r border-[#293891]/10 h-full hover:bg-white transition-colors">
                      <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-[#E63329]" style={{background:'rgba(230,51,41,0.08)'}}>
                        <Icon size={22}/>
                      </div>
                      <h3 className="font-display text-[20px] font-semibold text-[#293891] mt-6">{f.title}</h3>
                      <p className="text-[13.5px] leading-relaxed text-[#293891]/70 mt-3">{f.desc}</p>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <section id="tools" className="py-24 lg:py-32">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
          <Reveal><SectionLabel>Tools You'll Master</SectionLabel></Reveal>
          <div className="grid lg:grid-cols-[1.2fr_1fr] items-end gap-6 mt-6">
            <Reveal delay={0.05}>
              <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891]">
                The Data Scientist's <span className="text-[#E63329]">full stack.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="text-[15px] leading-relaxed text-[#293891]/75 max-w-md">
                Python, SQL, ML/DL frameworks, BI tools and Generative & Agentic AI — the exact toolkit modern data scientists use to ship.
              </p>
            </Reveal>
          </div>

          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
            {TOOLS.map((t,i) => (
              <Reveal key={t.name} delay={i*0.04}>
                <div className="card-lift bg-white border border-[#293891]/10 rounded-2xl p-5 flex items-start justify-between gap-3">
                  <div>
                    <div className="font-display text-[18px] font-semibold text-[#293891]">{t.name}</div>
                    <div className="text-[12px] text-[#293891]/60 mt-1">{t.tag}</div>
                  </div>
                  <div className="text-[11px] font-semibold text-[#E63329]">{String(i+1).padStart(2,'0')}</div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
